import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: {
    colors: { mineShaft },
    grey,
    primary: { normal },
    text
  },
  spacing: { unit }
}) => ({
  linkLabel: {
    color: grey.A700,
    marginTop: '10px',
    padding: `${unit}px ${unit}px 0`
  },
  linkTitle: {
    color: normal,
    padding: `${unit}px`,
    textTransform: 'capitalize'
  },
  reactDropdown: {
    fontSize: 14,
    marginBottom: 0,
    '& label': {
      display: 'none'
    },
    '& [class^="wrapper"]': {
      width: 130
    },
    '&[data-qa="dropdown-payment_templates"]': {
      '& [class^="wrapper"]': {
        width: 160
      }
    },
    '& [data-qa="filter-text-input"]': {
      border: 'none',
      borderBottom: `1px solid ${grey.A700}`
    },
    '& [class^="inputWrap"]': {
      fontFamily: 'Roboto Condensed, Roboto, ProximaNova, Helvetica, Arial, sans-serif',
      lineHeight: 'normal'
    },
    '& input': {
      border: `1px solid ${mineShaft}`,
      borderRadius: 3,
      paddingRight: 40,
      '&::placeholder': {
        color: normal || text.midGray,
        textAlign: 'center',
        fontSize: `${unit * 1.75}px`
      }
    },
    '& [class^="icon-caret-down"]': {
      fill: 'rgb(0, 112, 185)'
    },
    '& div[id*="dropdown-panel"]': {
      border: `1px solid ${normal}`,
      borderBottomRightRadius: 15,
      borderBottomLeftRadius: 15,
      color: grey,
      minWidth: '200px',
      width: '100%'
    },
    '& div[class^="panel"]': {
      boxShadow: 'none',
      zIndex: 101
    },
    '& ul': {
      maxHeight: 'none',
      overflowY: 'visible',
      borderBottomRightRadius: 15,
      borderBottomLeftRadius: 15
    }
  }
});

export default createUseStyles(styles);
